import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTransferwiseComponent } from './simple-icons-transferwise.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTransferwiseComponent ],
    exports:      [ SimpleIconsTransferwiseComponent ],
    bootstrap:    []
})
export class SimpleIconsTransferwiseModule {}
